export interface MobileCategoryBanner {
  id: string
  title: string
  description: string
  actionLabel: string
  categoryId: string
  image: string
}

export const mobileCategoryBanners: MobileCategoryBanner[] = [
  {
    id: 'wellness',
    title: 'Everyday wellness',
    description: 'Vitamins and essentials for your routine.',
    actionLabel: 'Shop vitamins',
    categoryId: 'vitamins',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c7b0b279-8cd3-4b5a-9fdc-7d76bc3dc89e.jpg',
  },
  {
    id: 'baby-care',
    title: 'Care for every stage',
    description: 'Baby and mother essentials, in one place.',
    actionLabel: 'Shop baby care',
    categoryId: 'baby-care',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/54e60fee-b7c3-44eb-aea0-a46547ea3800.jpg',
  },
  {
    id: 'skin-care',
    title: 'Your skin, your routine',
    description: 'Discover everyday beauty and skin care.',
    actionLabel: 'Shop beauty',
    categoryId: 'beauty',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d415c78f-55b9-42ea-aa70-927daee5c8d1.jpg',
  },
]
